import PracticeTitleContent from "../../../components/PracticeTitleContent";
import TitleEditor from "./TitleEditor";
import { useState } from "react";
import { myAxios, sanitizeUserInput } from "../../../utils/common";
import { useMutation } from "@tanstack/react-query";
import { TPracticeTypes } from "../../../types/practiceTypes";
import { toast } from "react-toastify";
import MonacoEditor from "../../../components/MonacoEditor";
import { TPracticeLang } from "../adminTypes";
import TripleLayout from "../../mySandpack/TripleLayout";
import PythonOutput from "../../practiceItem/PythonOutput";

interface IAddTestForm {
  unit_ml_part_id: number;
  type: TPracticeTypes;
  description: {
    title: string;
    answer: string;
    preText: string;
  };
  language: TPracticeLang;
}

export default function AddPythonPractice({ partId }: { partId?: number }) {
  const [form, setForm] = useState<{
    title: string;
    answer: string;
    preText: string;
    language: TPracticeLang;
  }>({
    title: "Deneme 1 2",
    answer: "",
    preText: "",
    language: "python",
  });

  const addTestPracticeMutation = useMutation({
    mutationFn: async (data: IAddTestForm) =>
      myAxios.post("/unit-ml-part-practice/", data).then((r) => r.data),
    onSuccess: (stuff) => {
      console.log(stuff);
      toast.success("Soru eklendi!");
    },
  });

  const handleSave = () => {
    const newPractice = {
      unit_ml_part_id: partId || 1000,
      type: "PYTHON" as TPracticeTypes,
      description: {
        title: form.title,
        preText: form.preText,
        answer: form.answer,
      },
      language: form.language,
    };
    /* edit ya da post querysi */
    addTestPracticeMutation.mutate(newPractice);
  };

  return (
    <div className="max-w-3xl mx-auto pt-4 space-y-3 w-full">
      <div className="bg-black/60 rounded-2xl border border-white/10">
        <div className="border-b border-white/10 p-4">
          <TitleEditor
            value={form.title}
            setValue={(newTitle) =>
              setForm((prev) => ({ ...prev, title: newTitle }))
            }
            step={1}
          >
            Soru metnini yaz
          </TitleEditor>
        </div>
      </div>

      <TripleLayout
        cx="h-132"
        left={
          <div className="text-base leading-normal h-full overflow-auto relative group">
            <div className="py-6 px-5 mb-2">
              <div className="practiceTitle font-medium p-6 text-white">
                <PracticeTitleContent title={sanitizeUserInput(form.title)} />
              </div>
            </div>
          </div>
        }
        right={[
          <div className="flex flex-col h-full">
            <p className="bg-black text-myOrange p-2 border-b">Verilen kod</p>
            <MonacoEditor
              cx="animate-fadeIn animate-faster"
              language={form.language || "javascript"}
              value={form.preText}
              key="preTextEditor"
              handleChange={(s) =>
                setForm((prev) => ({
                  ...prev,
                  preText: s,
                }))
              }
            />
            <p className="bg-black text-myOrange p-2 border-b">İstenen kod</p>
            <MonacoEditor
              cx="animate-fadeIn animate-faster"
              language={form.language || "javascript"}
              value={form.answer}
              key="answerEditor"
              handleChange={(s) =>
                setForm((prev) => ({
                  ...prev,
                  answer: s,
                }))
              }
            />
          </div>,
          <PythonOutput code={form.answer} />
        ]
        }
      />

      {/* <div className="bg-black/80 rounded-3xl p-2 border border-myGb/50">
        <div className="flex transition-all relative group rounded-2xl text-white">
          <div className="text-base leading-normal font-medium practiceTitle p-10 grow min-w-72">
            <PracticeTitleContent title={sanitizeUserInput(form.title)} />
          </div>

          
        </div>
      </div> */}

      <div className="flex items-center gap-4">
        <button
          className="practice-button"
          type="submit"
          form="add_practice_form"
          onClick={handleSave}
        >
          Kaydet
        </button>
      </div>
    </div >
  );
}
